import { useTranslation } from 'react-i18next'

import {
  DragDropDraggableItem,
  DRAGGING_KEEP_IN_PLACE_STYLE,
} from '../../../../DragDrop'
import {
  isRequestBoardCardDraggable,
  isRequestBoardCardPending,
  isRequestBoardCardStatusEditable,
} from '../../RequestBoard.utils'
import { RequestBoardCard } from '../../RequestBoardCard'
import { RequestBoardColumnSkeleton } from '../RequestBoardColumnSkeleton'

import { REQUEST_BOARD_COLUMN_CARDS_MORE_SKELETON_CARDS } from './RequestBoardColumnCards.constants'

function RequestBoardColumnCards({
  cardProps,
  column: { getThresholdCardProps, isLoadingMore, items, status },
  pendingIds,
}) {
  const { t } = useTranslation()

  return (
    <>
      {items.map(item => (
        <DragDropDraggableItem
          hasInteractiveChildren
          keepInPlace
          draggableProps={{
            data: { item, status },
            disabled: !isRequestBoardCardDraggable({ item, pendingIds }),
          }}
          draggingStyle={DRAGGING_KEEP_IN_PLACE_STYLE}
          id={item.id}
          key={item.id}
        >
          <RequestBoardCard
            {...cardProps}
            {...getThresholdCardProps(item)}
            isPending={isRequestBoardCardPending({ item, pendingIds })}
            item={item}
            tooltip={
              isRequestBoardCardStatusEditable(item)
                ? null
                : t('Request.BoardCardStatusLockedKey')
            }
          />
        </DragDropDraggableItem>
      ))}
      {isLoadingMore ? (
        <RequestBoardColumnSkeleton
          cards={REQUEST_BOARD_COLUMN_CARDS_MORE_SKELETON_CARDS}
        />
      ) : null}
    </>
  )
}

export default RequestBoardColumnCards
